import jQuery from 'jquery';
const $ = jQuery;

import 'cssuseragent';
import 'jquery.easing';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

window.jQuery = $;
window.$ = $;

// import Carousel from './Carousel';
import PerfectScrollbar from 'perfect-scrollbar';
import SlickSlider from './SlickSlider';
import ContentSwitcher from './ContentSwitcher';
import MenuListItem from './MenuListItem';
import Sticky from './Sticky';
import Accordion from './Accordion';
import ScrollFx from './ScrollFx';
import StickyProductNav from './StickyProductNav';
import PhilosophyCommon from './PhilosophyCommon';
import Slideshow from './Slideshow';

if(navigator.userAgent.indexOf('iPad') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') == -1)) {
  document.documentElement.classList.add('ua-tablet');
  document.querySelector("meta[name='viewport']").setAttribute("content", "width=1200");
}

class MainApp {
  constructor() {
    this.$window = $(window);

    this.viewMode         = '';
    this.prevScrollTop    = 0;
    this.scrollDiff       = 0;
    this.isShowPcHeader   = true;
    this.isShowSpHeader   = true;
    this.isOpenSpMenu     = false;
    this.canMoveHeader    = true;
    this.canMoveSpHeader  = true;
    this.onAnchorScroll   = false;
    this.isPhilosophy     = false;

    this.sticky           = new Sticky(this);
    this.contentSwitcher  = undefined;
    this.scrollFx         = new ScrollFx(this);
    this.scrollbar        = [];
    this.currentModal     = undefined;

    $('.GNavListItem--has-dropdown').each((i, e) => {
      new MenuListItem(this, $(e));
    });

    $('.js-open-modal').on('click', (e) => {
      let targetModalId = '#' + $(e.currentTarget).attr('data-modal');
      this.currentModal = $(targetModalId);
      this.onWindowResize();
      $('body').css('overflow-y', 'hidden');
      this.currentModal
        .stop(false)
        .css({'opacity':0, 'display':'block'})
        .animate({'opacity':1}, 300, 'easeInOutSine');
      return false;
    });

    $('.Modal, .js-close-modal').on('click', () => {
      $('body').css('overflow-y', 'auto');
      this.currentModal
        .stop(false)
        .animate({'opacity':0}, 300, 'easeInOutSine', () => {
          this.currentModal.css('display', 'none');
        });
      return false;
    });

    $('.Modal a').on('click', (e) => {
      e.stopPropagation();
    });

    $('.ModalPanelContainer').on('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
    });



    // SPメニュー
    $('.BtnToggleSpMenu').on('click', () => {
      if(this.isOpenSpMenu) {
        this.isOpenSpMenu = false;
        $('body').removeClass('open-sp-menu');
        $('html, body').scrollTop(this.prevScrollTop);
      } else {
        this.isOpenSpMenu = true;
        $('body').addClass('open-sp-menu');
      }
    });

    // トップへもどる
    $('.js-back-to-top').on('click', () => {
      $('html, body').animate({'scrollTop': 0}, 1200, 'easeInOutExpo');
    });

    $('.js-link-anchor').on('click', (e) => {
      let options = {
        'target': '',
        'offset': 0
      };
      if($(e.currentTarget).attr('data-anchor') != undefined) {
        options = Object.assign(options, JSON.parse($(e.currentTarget).attr('data-anchor')));
      }
      if($('#' + options['target']).length) {
        this.onAnchorScroll = true;
        $('html, body')
          .animate(
            {
              'scrollTop': $('#' + options['target']).offset()['top'] + options['offset']
            },
            900,
            'easeInOutExpo',
            () => {
              this.onAnchorScroll = false;
            }
          );
      }

      return false;
    });

    if($('.StickyProductNav').length) {
      this.productNav = new StickyProductNav(this);
    }

    if($('.PhilosophyPc').length) {
      new PhilosophyCommon(this);
      this.isPhilosophy = true;
    }

    if($('.Slideshow').length) {
      new Slideshow(this);
    }

    if($('.js-scrollbar').length) {
      $('.js-scrollbar').each((i, e) => {
        this.scrollbar.push(new PerfectScrollbar(e));

        if($(e).attr('data-scroll-stick-object') != undefined) {
          if($(e).attr('data-scroll-stick-object') == 'true') {
            $(e).on('ps-scroll-y', (e) => {
              $(e.currentTarget).find('.js-scroll-stick').css('margin-top', e.currentTarget.scrollTop);
            });
          }
        }
      });
    }

    this.$window
      .on('resize', ()=>{
        this.onWindowResize();
      })
      .on('scroll', ()=>{
        this.onWindowScroll();
      });
    this.onWindowResize();

    if($('.slick-slider').length) {
      new SlickSlider(this);
    }

    if($('.ContentSwitcher').length) {
      this.contentSwitcher = new ContentSwitcher(this);
    }

    if($('.Accordion').length) {
      $('.Accordion').each((i, e) => {
        new Accordion($(e));
      });
    }

  }

  onWindowScroll() {
    this.scrollTop = this.$window.scrollTop();

    if(this.scrollTop != this.prevScrollTop) {
      if(this.scrollTop > this.prevScrollTop) {
        this.scrollDiff = 1;
      } else {
        this.scrollDiff = -1;
      }
    }

    $('.Footer').css('left', this.$window.scrollLeft());

    if(this.productNav) {
      this.productNav.onWindowScroll(this.scrollTop);
    }

    if(this.contentSwitcher) {
      this.contentSwitcher.onWindowScroll(this.scrollTop);
    }

    if(this.viewMode != 'pc') {
      if(this.scrollTop > 60 && !this.isPhilosophy) {
        if(this.prevScrollTop < this.scrollTop) {
          // 下方向にスクロール時
          if(this.isShowSpHeader) {
            this.isShowSpHeader = false;
            $('.HeaderWrap').stop(false).animate({'margin-top': -60}, 500, 'easeOutExpo');
          }
        } else {
          // 上方向にスクロール時
          if(!this.isShowSpHeader && this.canMoveSpHeader && !this.onAnchorScroll) {
            this.isShowSpHeader = true;
            $('.HeaderWrap').stop(false).animate({'margin-top': 0}, 500, 'easeOutExpo');
          }
          if(!this.canMoveSpHeader) {
            this.isShowSpHeader = false;
            $('.HeaderWrap').stop(false).animate({'margin-top': -60}, 500, 'easeOutExpo');
          }
        }
      } else {
        if(!this.isShowSpHeader && !this.onAnchorScroll) {
          this.isShowSpHeader = true;
          $('.HeaderWrap').stop(false).animate({'margin-top': 0}, 500, 'easeOutExpo');
        }
      }

    } else {
      if(!this.isShowSpHeader && !this.onAnchorScroll) {
        this.isShowSpHeader = true;
        $('.HeaderWrap').stop(false).animate({'margin-top': 0}, 0);
      }
    }

    if(this.viewMode == 'pc') {
      if(this.scrollTop == this.prevScrollTop) {
        if(this.scrollDiff == 1) {
          if(this.isShowPcHeader) {
            this.isShowPcHeader = false;
            if($('.DomoHeader').hasClass('DomoHeader--fix')) {
              $('.DomoHeader')
                .stop(false)
                .animate({'top': -80}, 500, 'easeOutExpo');
            } else {
              $('.DomoHeader')
                .stop(false)
                .addClass('DomoHeader--fix')
                .css('top', -80);
            }

          }
        }
      } else if(this.prevScrollTop < this.scrollTop) {
        // 下方向にスクロール時
        if(this.scrollTop > 150) {
          if(this.isShowPcHeader) {
            this.isShowPcHeader = false;
            if($('.DomoHeader').hasClass('DomoHeader--fix')) {
              $('.DomoHeader')
                .stop(false)
                .animate({'top': -80}, 500, 'easeOutExpo');
            } else {
              $('.DomoHeader')
                .stop(false)
                .addClass('DomoHeader--fix')
                .css('top', -80);
            }

          }
        }
      } else {
        // 上方向にスクロール時
        if(this.scrollTop > 40) {
          if(!this.isShowPcHeader && this.canMoveHeader && !this.onAnchorScroll) {
            this.isShowPcHeader = true;
            $('.DomoHeader').stop(false).animate({'top': 0}, 500, 'easeOutExpo');
          }
          if(!this.canMoveHeader) {
            this.isShowPcHeader = false;
            $('.DomoHeader')
              .stop(false)
              .animate({'top': -80}, 500, 'easeOutExpo');
          }
        } else {
          $('.DomoHeader')
            .stop(false)
            .removeClass('DomoHeader--fix')
            .css({'top': 40});
        }
      }
    }

    this.sticky.onWindowScroll(this.scrollTop);
    this.scrollFx.onWindowScroll(this.scrollTop);

    if(!this.isOpenSpMenu) {
      this.prevScrollTop = this.scrollTop;
    }

  }

  onWindowResize() {
    this.windowWidth = this.$window.width();
    this.windowHeight = this.$window.height();

    if($('.check-view').width() == 1200) {
      this.viewMode = 'pc';
    } else if($('.check-view').width() == 1000) {
      this.viewMode = 'tablet';
    } else if($('.check-view').width() == 750) {
      this.viewMode = 'sp';
    }

    this.scrollFx.onWindowResize(this.windowHeight);

    if(this.productNav) {
      this.productNav.onWindowResize();
    }

    if(this.scrollbar.length > 0) {
      for(let i = 0; i < this.scrollbar.length; i++) {
        this.scrollbar[i].update();
      }
    }

    this.onWindowScroll();

    clearInterval(this.windowResizeInterval);
    this.windowResizeInterval = setInterval(() => {
      clearInterval(this.windowResizeInterval);
      this.onWindowResizeComplete()
    }, 300);
  }

  onWindowResizeComplete() {
    clearInterval(this.windowResizeInterval);

    if (this.viewMode !== 'sp' || !this.isPhilosophy) {
      $('body').css('padding-bottom', $('.Footer').outerHeight(true));
    }

    $('.ProductsListItem__btn').each((i, e) => {
      $(e).find('.ProductsListItem__hover').css('height', $(e).find('.ProductsListItem__img').position()['top'] + $(e).find('.ProductsListItem__img').height() + 15);
    });
  }

  onLoad() {
  }
}

$(document).ready(() => {
  /*
  $('.Debug').on('click', () => {
    if($('.Debug').hasClass('Debug--open')) {
      $('.Debug').removeClass('Debug--open');
    } else {
      $('.Debug').addClass('Debug--open');
    }
  });
  */
  new MainApp();
});
